var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasAssociations)?_c('CFileDownload',{staticClass:"readonly-meta-discount-associations",attrs:{"is-loading":_vm.isLoading,"placeholder":_vm.placeholder,"fileName":"discount_associations.csv"},on:{"download":_vm.downloadAssociationFile}}):_c('p',[_vm._v(_vm._s(_vm.$t('ctx.discount.detail.no-articles')))])
}
var staticRenderFns = []

export { render, staticRenderFns }